import type { CrudFilter, DataProvider } from "@refinedev/core";

import { API_BASE_URL, apiClient } from "@/services/api";

function buildQueryString(
  filters?: CrudFilter[],
  _sorters?: unknown[],
  pagination?: { current?: number; pageSize?: number },
) {
  const params = new URLSearchParams();
  if (pagination?.current && pagination?.pageSize) {
    params.append("offset", String((pagination.current - 1) * pagination.pageSize));
    params.append("limit", String(pagination.pageSize));
  }
  if (filters) {
    filters.forEach((filter) => {
      if ("field" in filter && "value" in filter) {
        params.append(filter.field, String(filter.value));
      }
    });
  }
  const query = params.toString();
  return query ? `?${query}` : "";
}

function dataPath(resource: string) {
  return `/data/${resource}`;
}

export const dataProvider: DataProvider = {
  getList: async ({ resource, filters, sorters, pagination }) => {
    const response = await apiClient.get(`${dataPath(resource)}${buildQueryString(filters, sorters, pagination)}`);
    return {
      data: response.data,
      total: response.data.length,
    };
  },
  getOne: async ({ resource, id }) => {
    const response = await apiClient.get(`${dataPath(resource)}/${id}`);
    return {
      data: response.data,
    };
  },
  create: async ({ resource, variables }) => {
    const response = await apiClient.post(dataPath(resource), { data: variables });
    return {
      data: response.data,
    };
  },
  update: async ({ resource, id, variables }) => {
    const response = await apiClient.put(`${dataPath(resource)}/${id}`, { data: variables });
    return {
      data: response.data,
    };
  },
  deleteOne: async <TData extends Record<string, unknown> = Record<string, unknown>>({
    resource,
    id,
  }: {
    resource: string;
    id: string | number;
  }) => {
    const response = await apiClient.delete(`${dataPath(resource)}/${id}`);
    return {
      data: response.data as TData,
    };
  },
  getApiUrl: () => API_BASE_URL,
};
